import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-carbon" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/">
              <img src="/assets/kalobrate-wordmark-yellow.png" alt="Kalobrate" className="h-7 w-auto mb-4" />
            </Link>
            <p className="text-friar text-sm mb-1">Making Workplace Culture Count</p>
            <a href="mailto:ollie@kalobrate.com" className="text-white/80 text-sm hover:text-golden transition-colors block mb-1">ollie@kalobrate.com</a>
            <a href="https://www.kalobrate.com" className="text-white/60 text-sm hover:text-golden transition-colors block mb-6">www.kalobrate.com</a>
            <a href="https://www.linkedin.com/in/ollie-bell-phd/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-white/60 text-sm hover:text-golden transition-colors" data-testid="footer-linkedin">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              LinkedIn
            </a>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-heading tracking-wide uppercase">Navigate</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/how-we-work" className="text-white/70 hover:text-golden transition-colors">How We Work</Link></li>
              <li><Link to="/services" className="text-white/70 hover:text-golden transition-colors">Services</Link></li>
              <li><Link to="/results" className="text-white/70 hover:text-golden transition-colors">Results</Link></li>
              <li><Link to="/about" className="text-white/70 hover:text-golden transition-colors">About</Link></li>
              <li><Link to="/insights" className="text-white/70 hover:text-golden transition-colors">Insights</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-golden transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4 font-heading tracking-wide uppercase">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="text-white/70 hover:text-golden transition-colors">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" className="text-white/70 hover:text-golden transition-colors">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-white/40 text-xs">&copy; {new Date().getFullYear()} Kalobrate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
